import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingFeatureComponent } from './upcoming-feature.component';
import { MaterialModuleMobi } from '../material/material.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { SidenavContentModule } from '../sidenav-content/sidenav-content.module';
import { SidenavModule } from '../sidenav/sidenav.module';
import { SidenavContentListModule } from '../sidenav-content-list/sidenav-content-list.module';
import { MobileScreenModule } from '../mobile-screen/mobile-screen.module';
import { CdkDrag, CdkDropListGroup, DragDropModule } from '@angular/cdk/drag-drop';
import { ApiconfigModule,AppPermissionsPipe,SharedModule } from 'shared-library';
import { PublishAppModule } from '../publish-app/publish-app.module';
import { SharedService } from '../Services/shared.service';
import { RouterModule, Routes } from '@angular/router';
import { EntitySubmissionDetailsModule } from '../entity-submission-details/entity-submission-details.module';
import { PrivacyPolicyModule } from '../privacy-policy/privacy-policy.module';
import { MediaModule } from '../media/media.module';

const routes: Routes = [
    { path: '',component:UpcomingFeatureComponent} ];
    
@NgModule({
  declarations: [UpcomingFeatureComponent],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    ToolbarModule,
    SidenavContentModule,
    SidenavContentListModule,
    SidenavModule,
    MobileScreenModule,
    CdkDropListGroup,
    DragDropModule,CdkDrag,
    ApiconfigModule,
    PublishAppModule,
    SharedModule,
    RouterModule.forChild(routes),
    EntitySubmissionDetailsModule,
    PrivacyPolicyModule,
    MediaModule,
    AppPermissionsPipe,
  ],
  exports:[
    UpcomingFeatureComponent,
  ],
  providers:[SharedService]
})
export class UpcomingFeatureModule { }
